import React, { useEffect, memo, useState } from 'react'
import { connect } from 'react-redux';
import { compose } from 'redux';
import Layout from '../../../components/Layout';
import { useParams } from 'react-router-dom';
import { getDataProgul_act } from "../../../../redux/ducks/progul/actions"
import BackButton from '../../../components/BackButton';

const tahun = [2021,2022,2023,2024,2025,2026]
const DataProgramUnggulan = (props) => {
    const { progulId, progulName, yearconfig } = useParams();
    const initBreadcrumbs = [
        {
          title: 'Home',
          isActive: true,
          goTo: '/tahun/'+yearconfig,
        },
        {
          title: `Program Unggulan`,
          isActive: true,
          goTo: `/tahun/${yearconfig}/progul/tema`,
        },
    ];
    const [breadCrumbsData, setBreadCrumbsData] = useState();
    useEffect(() => {
        setBreadCrumbsData([...initBreadcrumbs, {
            title: progulName,
            isActive: false,
            goTo: ''
        }])
    },[])
    useEffect(() => {
        props.getDataProgul(progulId)
    },[])
    return (
        <Layout
            loading={props.dataProgul.loadingGet}
            breadCrumbsData={breadCrumbsData}
        >
          <div
              className="bg-white rounded-lg drop-shadow-2xl py-5 px-2 w-full"
          >
              <div className="flex-grow bg-white rounded-xl py-2 relative">
                  <h3 className="text-sm text-secondaryColor1 text-center">Program Unggulan</h3>
                  <h1 className="text-lg font-bold text-center text-primeColor1">{progulName}</h1>
                  <hr className="mb-3" />
              </div>
              
              <div className="w-full flex flex-col justify-center sm:overflow-visible overflow-x-auto">
                    <table className="w-full table-auto text-xs mb-4">
                        <thead className="bg-primeColor1 text-white sticky top-0">
                            <tr>
                                <th className="border border-slate-500 md:w-1/4" rowSpan={3}>
                                    Indikator
                                </th>
                                <th className="border border-slate-500" rowSpan={3}>
                                    Satuan
                                </th>
                                <th className="border border-slate-500" colSpan={tahun.length * 2}>
                                    Tahun
                                </th>
                                
                                <th className="border border-slate-500 md:w-1/12" rowSpan={3}>
                                    Perangkat Daerah
                                </th>
                            </tr>
                            <tr>
                                {
                                    tahun.map((item) => {
                                        return (
                                            <th className="border border-slate-500" colSpan={2}>{item}</th>
                                        )
                                    })
                                }
                            </tr>
                            <tr>
                                {
                                    tahun.map((item) => {
                                        return (
                                            <>
                                                <th className="border border-slate-500">
                                                    <span className="md:block hidden">Target</span>
                                                    <span className="md:hidden block">T</span>
                                                </th>
                                                <th className="border border-slate-500">
                                                    <span className="md:block hidden">Capaian</span>
                                                    <span className="md:hidden block">C</span>
                                                </th>
                                            </>
                                        )
                                    })
                                }
                            </tr>
                            
                        </thead>
                        <tbody>
                            {
                                props.dataProgul ? props.dataProgul.data.map((item, keys) => {
                                    const indikator = renderIndikator(item.indikator)
                                    const defops = item.definisi_operasional.split('</br>');
                                    let newDefops = defops.map((item) => {
                                        return  <>
                                            {item} <br />
                                        </> 
                                    })
                                    const definisi_operasional = (
                                        <>
                                            <tr key={keys}>
                                                <td className="border border-slate-500 font-bold py-2 px-5 bg-primeColor2" colSpan={15}>&nbsp;</td>
                                            </tr>
                                            {
                                                indikator
                                            }
                                        </>
                                    )
                                    return (definisi_operasional)
                                }) : 
                                <tr>
                                    <td className="border border-slate-500 py-2 px-5 bg-green-200" colSpan={15}>Loading...</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    <span className="text-red-400 text-xs font-bold">
                        Notes : <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; *) Data triwulan IV
                    </span>
                </div>
          </div>
            <BackButton backLink={`/tahun/${yearconfig}/progul/tema`} />
        </Layout>
    )
}

const renderIndikator = (list) => {
    return list?.map((val, keys) => {
        return (
            <tr className='odd:bg-secondaryColor2' key={keys}>
                {/* <td className="border border-slate-500 p-2 text-center">{keys+1}</td> */}
                <td className={`border border-slate-500 py-2 pr-2 ` + (val.tabs ? `pl-${(val.tabs*10)}` : `pl-2`) }>{val.kode} {val.indikator}</td>
                <td className="border border-slate-500 p-2 text-center">{val.satuan}</td>
                {
                    tahun.map((item) => {
                        return (
                            <>
                                <td className="border border-slate-500 p-2 text-center">{val[`target_${item}`]}</td>
                                <td className="border border-slate-500 p-2 text-center">{val[`capaian_${item}`]}</td>
                            </>
                        )
                    })
                }
                <td className="border border-slate-500 p-2">{val.perangkat_daerah}</td>
            </tr>
        )
    })
}

const mapStateToProps = (state) => ({
    dataProgul: state.progulState.dataProgul
})

const mapDispatchToProps = {
    getDataProgul: getDataProgul_act
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(withConnect, memo)(DataProgramUnggulan)